import { Component, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbPagination } from "@ng-bootstrap/ng-bootstrap/pagination";

import { ApiService } from "src/app/api.service";
import { DatetimePipe, SentEmailStatusColorPipe } from "src/app/pipes";
import { APIResults, AssetRoutable } from "src/app/sharedinterfaces";

@Component({
	selector: "app-fleetwide-email",
	templateUrl: "./fleetwide-sent-email.component.html",
	styleUrls: ["./fleetwide-sent-email.component.scss"],
	imports: [FormsModule, NgbPagination, DatetimePipe, SentEmailStatusColorPipe]
})
export class FleetwideSentEmailComponent implements OnInit {
	api = inject(ApiService);

	@Output()
	public AssetSelected = new EventEmitter<AssetRoutable>();

	public noDelivered = false;
	public totalEmails = 0;
	public currentPage = 1;
	public itemsPerPage = 20;
	public pageLogs: APIResults.SentEmail[];
	public pageLoading = false;
	public assetList: any[] = [];
	public selectedAsset: any = null;
	public filters: any = {};

	async ngOnInit() {
		await this.refreshTable();
		const assets = await this.api.GetAllAssets();
		assets.sort((a, b) => (a.fleet_name ?? "").localeCompare(b.fleet_name ?? "") || a.asset_name.localeCompare(b.asset_name));
		this.assetList = assets;
	}

	async refreshTable() {
		this.currentPage = 1;
		await this.updatePage();
	}

	async updatePage() {
		try {
			this.pageLoading = true;
			const result = await this.api.GetSentEmails(this.noDelivered, this.filters.asset?.asset_id, this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage);
			this.totalEmails = result.count;
			this.pageLogs = result.rows;
		} finally {
			this.pageLoading = false;
		}
	}

	async FilterAsset(asset: any) {
		this.filters.asset = {
			asset_id: asset.asset_id,
			name: asset.asset_name,
		};
		this.refreshTable();
	}

	removeFilter(field: string) {
		this.filters[field] = null;
		if (field === "asset") this.selectedAsset = null;
		this.refreshTable();
	}

	public SelectAsset(target: APIResults.SentEmail) {
		if (target.asset_id && target.fleet_id) {
			this.AssetSelected.emit(target as AssetRoutable);
		}
	}
}
